import { type FC } from "react";
import { MobileHeaderNavMenu, MobileHeaderTitle } from "@/common/AppMobileHeader";
import { MenuSorterDropdown } from "@/common/AppHeader/mobile/Components/Menu/MenuSorterDropdown";
import type { MenuSorterOptions } from "@/common/AppHeader/mobile/Components/Menu/MenuSorterList";
import styles from "./styles.module.scss";

type Props = {
  onClickTitle?: () => void;
  showBackArrow?: boolean;
  title?: string;
  showMenu?: boolean;
  onSorterMenuChange?: (sortType: MenuSorterOptions) => void;
  showSorter?: boolean;
  sorterMenuValue?: MenuSorterOptions;
};

export const BaseMobileHeader: FC<Props> = ({
  onClickTitle = () => "",
  showBackArrow = false,
  showMenu = true,
  showSorter,
  sorterMenuValue = null,
  onSorterMenuChange = () => "",
  title = "",
}) => {
  return (
    <div className={styles["header"]}>
      <MobileHeaderTitle onClick={onClickTitle} backArrow={showBackArrow} title={title} />
      <div className={styles["action-menu"]}>
        {showSorter && (
          <MenuSorterDropdown sorterMenuValue={sorterMenuValue} onMenuChange={onSorterMenuChange} />
        )}
        {showMenu && <MobileHeaderNavMenu />}
      </div>
    </div>
  );
};
